<template>
  <div>
    <div class="renderHalfHour">
      <div class="firstDateForm" @click="showStartDatePopup = true">
        <span>{{ moment(startDate).format('HH:mm') }}</span>
        <span>{{ getNowFormatDate(startDate) }}
          {{ formatDate(startDate).split(' ')[1] }}</span>
      </div>
      <img class="arrow_left" src="@/assets/images/arrow-left-f@2x.png" alt="" />
      <div class="firstDateForm" @click="showEndDatePopup = true">
        <span>{{ moment(endDate).format('HH:mm') }}</span>
        <span>{{ getNowFormatDate(endDate) }}
          {{ formatDate(endDate).split(' ')[1] }}</span>
      </div>
    </div>

    <div class="appointmentTime">
      {{ $t('已选择 ') }}{{ diffNum }}{{ $t(' 小时') }}
    </div>
    <!-- 开始时间 -->
    <van-popup v-model="showStartDatePopup" position="bottom" v-if="showStartDatePopup" @close-on-click-overlay="false">
      <van-datetime-picker type="datetime" :title="$t('选择年月日小时')" :value="startDate" :filter="filterStartDateDay"
        :min-date="minDate" :max-date="maxStartDate" @confirm="handleConfirmStartDay"
        @cancel="showStartDatePopup = false" @change="handleChangeStartDay" />
    </van-popup>
    <!-- 结束时间 -->
    <van-popup v-model="showEndDatePopup" position="bottom" v-if="showEndDatePopup" @close-on-click-overlay="false">
      <van-datetime-picker type="datetime" :title="$t('选择年月日小时')" :value="endDate" :filter="filterEndDateDay"
        :min-date="minDate" :max-date="maxEndDate" @confirm="handleConfirmEndDay" @cancel="showEndDatePopup = false"
        @change="handleChangeEndDay" />
    </van-popup>
  </div>
</template>
<script>
import { fixNewDate } from '@/utils/utils'
import Vue from 'vue'
import {
  getNowFormatDate,
  formatDate,
  formatDateYMD,
  formatDateYMDHMS,
  mergeTimeRanges,
  // excludeTimeRanges,
  formatDateOrigin,
} from '@/views/station/utils'
import dayjs from 'dayjs'
import moment from 'moment'
import { queryDisableDate } from '@/services/api'

import { Toast } from 'vant'

Vue.use(Toast)

export default {
  name: 'RenderHalfHour',
  data() {
    return {
      showStartDatePopup: false,
      showEndDatePopup: false,
      // startDate: new Date(
      //   fixNewDate(
      //     `${dayjs(this.$route.params.startTime).format('YYYY-MM-DD')} ${dayjs().format(
      //       'HH'
      //     )}:00:00`
      //   )
      // ), // 开始日期（年月日-天）
      startDate: new Date(
        fixNewDate(
          `${dayjs(this.$route.params.startTime).format(
            'YYYY-MM-DD'
          )} ${dayjs().format('HH:mm')}:00`
        )
      ),
      endDate: new Date(
        fixNewDate(
          `${dayjs(this.$route.params.startTime).format(
            'YYYY-MM-DD'
          )} ${dayjs().format('HH:mm')}:00`
        )
      ), // 结束日期（年月日-天）\
      diffNum: 0.5,
      bookedDates: [],
      disHistoryHours: [], // 已经预约的小时
      changeStartValue: moment().format('YYYY-MM-DD HH:mm:ss'),
      changeEndValue: moment().format('YYYY-MM-DD HH:mm:ss'),
      minDate: new Date(),
      maxStartDate: new Date(),
      // minEndDate: new Date(),
      maxEndDate: new Date(),
      getNowFormatDate,
      formatDate,
      formatDateYMD,
      formatDateYMDHMS,
      mergeTimeRanges,
      formatDateOrigin,
      moment,
    }
  },
  methods: {
    async initQuery() {
      const maxMakeDay = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      try {
        const res = await queryDisableDate({
          stationId: this.checkedStationId,
          startTime: `${dayjs().format('YYYY-MM-DD')} 00:00:00`,
          endTime: `${dayjs()
            .add(maxMakeDay, 'day')
            .format('YYYY-MM-DD')} 23:59:59`,
          type: 'HALF_A_HOUR',
        })
        let sortByStartTime = []
        // 1. 按照开始时间进行生序
        sortByStartTime = res?.data.sort(
          (a, b) =>
            moment(a.startTime).valueOf() - moment(b.startTime).valueOf()
        )
        // 2. 相邻的时间段进行合并
        let newDateList = this.mergeTimeRanges(sortByStartTime)

        // 3. 根据历史预约数据，求出每个时间断中，禁止点击的小时。比如：13-15之间是14，但是18-19之间没有。
        let disHistoryHours = []
        newDateList?.forEach((it) => {
          const start = moment(it.startTime).hour()
          const end = moment(it.endTime).hour()
          console.log('end', end)

          if (end - start >= 2) {
            const diff = end - start
            for (let index = 1; index <= diff - 1; index++) {
              disHistoryHours.push(start + index)
            }
          }
        })

        this.disHistoryHours = disHistoryHours
        this.bookedDates = newDateList

        // 初始化更新一下值
        // const rangeDateForSubmit = excludeTimeRanges(
        //   {
        //     startTime: formatDateYMDHMS(this.startDate),
        //     endTime: formatDateYMDHMS(this.endDate),
        //   },
        //   this.bookedDates
        // )
        const rangeDateForSubmit = [
          {
            startTime: formatDateYMDHMS(this.startDate),
            endTime: formatDateYMDHMS(this.endDate),
          },
        ]

        this.onChangeDate('start', this.startDate, this.endDate, rangeDateForSubmit)
        // this.onChangeDate('end', this.endDate, rangeDateForSubmit)
      } catch (error) {
        console.log(error)
      }
    },
    initSetDate() {
      const maxDate = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      const singleMaxMakeTime = this.appointmentConfig.singleMaxMakeTime
        ? this.appointmentConfig.singleMaxMakeTime
        : 1 // 用于小时、半小时

      let maxStartDate = new Date()
      maxStartDate.setHours(23, 59, 59, 999)
      // maxStartDate.setDate(this.startDate.getDate() + Number(maxDate) - 1)
      maxStartDate.setDate(new Date().getDate() + Number(maxDate) - 1)
      this.maxStartDate = maxStartDate

      let maxEndDate = new Date(this.startDate)
      maxEndDate.setHours(this.startDate.getHours() + Number(singleMaxMakeTime))
      if (maxEndDate.getTime() > maxStartDate.getTime()) {
        this.maxEndDate = maxStartDate
      } else {
        this.maxEndDate = maxEndDate
      }
      // this.maxEndDate = maxEndDate

      const isToday = dayjs(this.$route.params.startTime).isSame(dayjs(), 'day')
      if (isToday) {
        let initStartData = new Date(
          dayjs(this.startDate).clone().format('YYYY-MM-DD HH:mm:ss')
        )
        let initEndData = new Date(
          dayjs(this.startDate).add(30, 'minute').clone().format('YYYY-MM-DD HH:mm:ss')
        )
        initStartData.setMinutes(new Date().getMinutes() >= 30 ? 30 : 0)
        initEndData.setMinutes(initEndData.getMinutes() >= 30 ? 30 : 0)

        this.startDate = initStartData
        this.endDate = initEndData
        const rangeDateForSubmit = [
          {
            startTime: formatDateYMDHMS(this.startDate),
            endTime: formatDateYMDHMS(this.endDate),
          },
        ]

        this.onChangeDate('start', this.startDate, this.endDate, rangeDateForSubmit)
        // this.onChangeDate('end', this.endDate, rangeDateForSubmit)
      }
    },
    // 根据配置的最大预约时间显示过滤数据
    filterStartDay(type, options, day) {
      const currentCheckedDate = dayjs(day)
      const curY = dayjs().year()
      const curM = Number(dayjs().format('MM'))
      const curD = Number(dayjs().format('DD'))

      const maxDate = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      const maxMakeDay = dayjs().add(maxDate - 1, 'day') //最大预约天数

      const maxY = maxMakeDay.year()
      const maxM = Number(maxMakeDay.format('MM'))
      const maxD = Number(maxMakeDay.format('DD'))

      const curH = Number(dayjs().format('HH'))
      const curMi = Number(dayjs().format('mm'))

      const checkedH = Number(dayjs(this.changeStartValue).format('HH'))

      // const isCurDay = dayjs().format('YYYY-MM-DD') === this.formatDateOrigin(this.startDate)
      const isCurDay =
        dayjs().format('YYYY-MM-DD') ===
        dayjs(this.changeStartValue).format('YYYY-MM-DD')

      const isCurY =
        dayjs().format('YYYY') === currentCheckedDate.format('YYYY')
      const isCurM =
        dayjs().format('YYYY-MM') === currentCheckedDate.format('YYYY-MM')
      const checkedY = currentCheckedDate.year()
      const checkedM = currentCheckedDate.month() + 1

      const endH = this.appointmentConfig?.appointmentEndTime || 23 // 配置的每天最晚小时

      // if (type === 'year') {
      //   return options.filter(option => Number(option) >= curY && Number(option) <= maxY)
      // }
      // if (type === 'month') {
      //   if (isCurY) {
      //     if (checkedY === maxY) {
      //       return options.filter(option => Number(option) >= curM && Number(option) <= maxM)
      //     } else {
      //       return options.filter(option => Number(option) >= curM)
      //     }
      //   } else {
      //     if (checkedY === maxY) {
      //       return options.filter(option => Number(option) <= maxM)
      //     }
      //   }
      // }
      // if (type === 'day') {
      //   if (isCurY) {
      //     if (checkedY === maxY) {
      //       if (isCurM) {
      //         if (checkedM === maxM) {
      //           return options.filter(option => Number(option) >= curD && Number(option) <= maxD)
      //         } else {
      //           return options.filter(option => Number(option) >= curD)
      //         }
      //       } else {
      //         if (checkedM === maxM) {
      //           return options.filter(option => Number(option) <= maxD)
      //         }
      //       }
      //     }
      //   } else {
      //     if (checkedY === maxY) {
      //       if (checkedM === maxM) {
      //         return options.filter(option => Number(option) <= maxD)
      //       }
      //     }
      //   }
      // }

      // if (type === 'hour') {
      //   if (isCurDay) {
      //     return options.filter(option => Number(option) >= curH)
      //   } else {
      //     return options
      //   }
      // }
      // if (type === 'minute') {
      //   // 当天时间，在当前curH：30～curH+1:00之前的，不需要在显示curH:00的00分钟
      //   if (isCurDay) {
      //     if (Number(curH) === Number(this.startDate.getHours()) && Number(curM) >= 30) {
      //       options = options.filter(option => Number(option) >= 30)
      //     }
      //   }

      //   if (this.startDate.getHours() === endH) {
      //     return ['00']
      //   } else {
      //     if (this.startDate.getHours() === 23) {
      //       return options.filter(option => Number(option) % 30 === 0 || option === '59')
      //     } else {
      //       return options.filter(option => Number(option) % 30 === 0)
      //     }
      //   }
      // }

      if (type === 'minute') {
        if (isCurDay) {
          if (Number(curH) === Number(checkedH)) {
            if (Number(curMi) >= 30) {
              options = Number(checkedH) === 23 ? ['30', '59'] : ['30']
            } else {
              options =
                Number(checkedH) === 23 ? ['00', '30', '59'] : ['00', '30']
            }
          } else {
            options =
              Number(checkedH) === 23 ? ['00', '30', '59'] : ['00', '30']
          }
        } else {
          options = Number(checkedH) === 23 ? ['00', '30', '59'] : ['00', '30']
        }
      }
      return options
    },
    filterEndDay(type, options) {
      const currentCheckedDate = dayjs(this.startDate)
      const curY = dayjs().year()
      const curM = Number(dayjs().format('MM'))
      const curD = Number(dayjs().format('DD'))

      // const maxDate = this.appointmentConfig.maxMakeDay ? this.appointmentConfig.maxMakeDay : 20 // 最长预约天数
      const singleMaxMakeTime = this.appointmentConfig.singleMaxMakeTime
        ? this.appointmentConfig.singleMaxMakeTime
        : 5 // 单次最长预约天数
      const maxMakeDay = dayjs().add(singleMaxMakeTime - 1, 'day') //最大预约天数

      const maxY = maxMakeDay.year()
      const maxM = Number(maxMakeDay.format('MM'))
      const maxD = Number(maxMakeDay.format('DD'))

      const curH = Number(dayjs().format('HH'))
      const curMi = Number(dayjs().format('mm'))

      // const isCurDay = dayjs().format('YYYY-MM-DD') === this.formatDateOrigin(this.startDate)
      const isCurDay =
        dayjs().format('YYYY-MM-DD') ===
        dayjs(this.changeEndValue).format('YYYY-MM-DD')

      const checkedH = Number(dayjs(this.changeEndValue).format('HH'))

      const isCurY =
        dayjs().format('YYYY') === currentCheckedDate.format('YYYY')
      const isCurM =
        dayjs().format('YYYY-MM') === currentCheckedDate.format('YYYY-MM')
      const checkedY = currentCheckedDate.year()
      const checkedM = currentCheckedDate.month() + 1

      const endH = this.appointmentConfig?.appointmentEndTime || 23 // 配置的每天最晚小时

      // if (type === 'year') {
      //   return options.filter(option => Number(option) >= curY && Number(option) <= maxY)
      // }
      // if (type === 'month') {
      //   if (isCurY) {
      //     if (checkedY === maxY) {
      //       return options.filter(option => Number(option) >= curM && Number(option) <= maxM)
      //     } else {
      //       return options.filter(option => Number(option) >= curM)
      //     }
      //   } else {
      //     if (checkedY === maxY) {
      //       return options.filter(option => Number(option) <= maxM)
      //     }
      //   }
      // }
      // if (type === 'day') {
      //   if (isCurY) {
      //     if (checkedY === maxY) {
      //       if (isCurM) {
      //         if (checkedM === maxM) {
      //           return options.filter(option => Number(option) >= curD && Number(option) <= maxD)
      //         } else {
      //           return options.filter(option => Number(option) >= curD)
      //         }
      //       } else {
      //         if (checkedM === maxM) {
      //           return options.filter(option => Number(option) <= maxD)
      //         }
      //       }
      //     }
      //   } else {
      //     if (checkedY === maxY) {
      //       if (checkedM === maxM) {
      //         return options.filter(option => Number(option) <= maxD)
      //       }
      //     }
      //   }
      // }
      // if (type === 'hour') {
      //   if (isCurDay) {
      //     return options.filter(option => Number(option) >= curH)
      //   } else {
      //     return options
      //   }
      // }
      // if (type === 'minute') {
      //   // 当天时间，在当前curH：30～curH+1:00之前的，不需要在显示curH:00的00分钟
      //   if (isCurDay) {
      //     if (Number(curH) === Number(this.startDate.getHours()) && Number(curM) >= 30) {
      //       options = options.filter(option => Number(option) >= 30)
      //     }
      //   }

      //   if (this.startDate.getHours() === endH) {
      //     return ['00']
      //   } else {
      //     if (this.startDate.getHours() === 23) {
      //       return options.filter(option => Number(option) % 30 === 0 || option === '59')
      //     } else {
      //       return options.filter(option => Number(option) % 30 === 0)
      //     }
      //   }
      // }
      if (type === 'minute') {
        if (isCurDay) {
          if (Number(curH) === Number(checkedH)) {
            if (Number(curMi) >= 30) {
              options = Number(checkedH) === 23 ? ['30', '59'] : ['30']
            } else {
              options =
                Number(checkedH) === 23 ? ['00', '30', '59'] : ['00', '30']
            }
          } else {
            options =
              Number(checkedH) === 23 ? ['00', '30', '59'] : ['00', '30']
          }
        } else {
          options = Number(checkedH) === 23 ? ['00', '30', '59'] : ['00', '30']
        }
      }
      return options
    },
    // 过滤年月日-开始
    filterStartDateDay(type, options) {
      const curOptions = this.filterStartDay(type, options, this.startDate)
      return curOptions
    },
    // 过滤年月日-结束
    filterEndDateDay(type, options) {
      const curOptions = this.filterEndDay(type, options, this.endDate)
      return curOptions
    },
    // 确认开始
    handleConfirmStartDay(date) {
      date.setMinutes(
        date.getMinutes() >= 30 ? (date.getMinutes() === 59 ? 59 : 30) : 0
      )

      if (date.getHours() === 23 && date.getMinutes() === 59) {
        Toast(this.$t('开始时间不能是23点59分'))
        return
      } else if (date.getHours() === 23 && date.getMinutes() === 30) {
        this.endDate = new Date(fixNewDate(dayjs(date).add(29, 'minute').format('YYYY-MM-DD HH:mm:59')))
      } else {
        this.endDate = new Date(fixNewDate(dayjs(date).add(30, 'minute').format('YYYY-MM-DD HH:mm:00')))
      }
      this.startDate = date
      this.showStartDatePopup = false

      const singleMaxMakeTime = this.appointmentConfig.singleMaxMakeTime
        ? this.appointmentConfig.singleMaxMakeTime
        : 1 // 用于小时、半小时
      let maxEndDate = new Date(this.startDate)
      if (this.startDate.getHours() === 23) {
        maxEndDate.setHours(
          this.startDate.getHours() + Number(singleMaxMakeTime) - 1
        )
      } else {
        maxEndDate.setHours(
          this.startDate.getHours() + Number(singleMaxMakeTime)
        )
        if (this.startDate.getMinutes() === 30) {
          maxEndDate.setMinutes(30)
        } else if (this.startDate.getMinutes() === 59) {
          maxEndDate.setMinutes(59)
        } else {
          maxEndDate.setMinutes(0)
        }
      }
      if (maxEndDate.getTime() > this.maxStartDate.getTime()) {
        this.maxEndDate = this.maxStartDate
      } else {
        this.maxEndDate = maxEndDate
      }

      // const rangeDateForSubmit = excludeTimeRanges(
      //   {
      //     startTime: formatDateYMDHMS(this.startDate),
      //     endTime: formatDateYMDHMS(this.endDate),
      //   },
      //   this.bookedDates
      // )
      const rangeDateForSubmit = [
        {
          startTime: formatDateYMDHMS(this.startDate),
          endTime: formatDateYMDHMS(this.endDate),
        },
      ]
      this.diffNum = dayjs(this.endDate).diff(this.startDate, 'hour') == 0 ? 0.5 : dayjs(this.endDate).diff(this.startDate, 'hour')
      this.onChangeDate('start', date, this.endDate, rangeDateForSubmit)
      // this.onChangeDate('end', this.endDate, rangeDateForSubmit)
    },
    handleConfirmEndDay(date) {
      date.setMinutes(
        date.getMinutes() >= 30 ? (date.getMinutes() === 59 ? 59 : 30) : 0
      )
      if (date.getHours() == 0 && date.getMinutes() == 0) {
        Toast(this.$t('结束时间不能是零点'))
        return
      }
      if (
        dayjs(date).isBefore(this.startDate) ||
        !dayjs(date).isSame(this.startDate, 'day') ||
        (dayjs(date).isSame(this.startDate, 'day') && dayjs(date).isSame(this.startDate, 'hour') && dayjs(date).isSame(this.startDate, 'minute'))
      ) {
        if (dayjs(date).isSame(dayjs(this.minDate), 'hour') && dayjs(date).isBefore(dayjs(this.minDate))) {
          Toast(this.$t('结束时间必须早于当前时间'))
          return
        } else if (date.getHours() === 23 && date.getMinutes() === 59) {
          this.startDate = new Date(fixNewDate(dayjs(date).subtract(29, 'minute').format('YYYY-MM-DD HH:mm:00')))
        } else {
          this.startDate = new Date(fixNewDate(dayjs(date).subtract(30, 'minute').format('YYYY-MM-DD HH:mm:00')))
        }
      }

      this.endDate = date
      this.showEndDatePopup = false

      // 计算小时差

      let diff = 0

      let start = this.startDate.getHours()
      const end = this.endDate.getHours()

      while (start < end) {
        start += 1

        // const isExit = this.disHistoryHours.find(h => h === start)
        // 已预约的时间不在校验，因为提交的时候穿的是全量的日期
        const isExit = false
        if (!isExit) {
          diff += 1
        }
      }

      // 分钟计算
      const startMinutes = this.startDate.getMinutes()
      const endMinutes = this.endDate.getMinutes()
      if (startMinutes === 30) {
        diff -= 0.5
      }
      if (endMinutes === 30) {
        diff += 0.5
      }
      if (endMinutes === 59) {
        diff += 1
      }

      const singleMaxMakeTime = this.appointmentConfig.singleMaxMakeTime
        ? this.appointmentConfig.singleMaxMakeTime
        : 1 // 用于小时、半小时
      if (diff > singleMaxMakeTime) {
        if (date.getHours() === 23 && date.getMinutes() === 59) {
          this.startDate = new Date(fixNewDate(dayjs(date).subtract(29, 'minute').format('YYYY-MM-DD HH:mm:00')))
        } else {
          this.startDate = new Date(fixNewDate(dayjs(date).subtract(30, 'minute').format('YYYY-MM-DD HH:mm:00')))
        }
        Toast(this.$t('超过了单次可预约的最大小时'))
        this.handleConfirmStartDay(this.startDate)
        // this.startDate = date
        diff = 0.5
      }

      this.diffNum = diff

      // const rangeDateForSubmit = excludeTimeRanges(
      //   {
      //     startTime: formatDateYMDHMS(this.startDate),
      //     endTime: formatDateYMDHMS(this.endDate),
      //   },
      //   this.bookedDates
      // )
      const rangeDateForSubmit = [
        {
          startTime: formatDateYMDHMS(this.startDate),
          endTime: formatDateYMDHMS(this.endDate),
        },
      ]
      this.onChangeDate('start', this.startDate, date, rangeDateForSubmit)
      // this.onChangeDate('end', date, rangeDateForSubmit)
    },
    handleChangeStartDay(event) {
      const cY = event.getValues()[0]
      const cM = event.getValues()[1]
      const cD = event.getValues()[2]
      const cH = event.getValues()[3]
      this.changeStartValue = `${cY}-${cM}-${cD} ${cH}:00:00`
      this.changeEndValue = `${cY}-${cM}-${cD} ${cH}:00:00`
    },
    handleChangeEndDay(event) {
      const cY = event.getValues()[0]
      const cM = event.getValues()[1]
      const cD = event.getValues()[2]
      const cH = event.getValues()[3]
      this.changeEndValue = `${cY}-${cM}-${cD} ${cH}:00:00`
    },
  },
  mounted() {
    this.initSetDate()
  },

  watch: {
    checkedStationId(newValue, oldValue) {
      newValue && this.initQuery()
    },
  },
  props: ['appointmentConfig', 'onChangeDate', 'checkedStationId'],
}
</script>
<style lang="less" scoped>
.renderHalfHour {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 18px 0;

  .firstDateForm {
    line-height: 24px;
    text-align: left;
    font-style: normal;
    display: flex;
    flex-direction: column;

    & span:nth-child(1) {
      color: #1e2329;
      font-weight: 600;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-size: 18px;
    }

    & span:nth-child(2) {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #474d57;
    }
  }

  .arrow_left {
    width: 24px;
    height: 24px;
  }
}

.appointmentTime {
  padding: 10px 0 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b7bdc6;
  border-top: 1px solid rgba(234, 236, 239, 0.5);
}
</style>
